import React, { useState } from "react";
import "../css/ComingSoon.css";

function ComingSoon({ onUnlock }) {
  const [showPasswordBox, setShowPasswordBox] = useState(false);
  const [password, setPassword] = useState("");

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      if (password === "letmeinpls") {
        onUnlock();
      } else {
        alert("Wrong password 😅");
        setPassword("");
      }
    }
  };

  return (
    <div id="ComingSoon">
      <div className="coming-text">
        <span
          onClick={() => setShowPasswordBox(true)}
          style={{ cursor: "pointer", fontWeight: "bold" }}
        >
          c
        </span>
        oming soon...
      </div>

      {showPasswordBox && (
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Enter password"
          autoFocus
          className="coming-password"
        />
      )}
    </div>
  );
}

export default ComingSoon;